import { render } from "./StackedBarChart.vue?vue&type=template&id=0f1b49a5&scoped=true"
import script from "./StackedBarChart.vue?vue&type=script&lang=js"
export * from "./StackedBarChart.vue?vue&type=script&lang=js"

import "./StackedBarChart.vue?vue&type=style&index=0&id=0f1b49a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1b49a5"]])

export default __exports__